<style lang="less">
.draw-price-container {
  width: 750px;
  height: 100%;
  background: #f7f7f7;
  font-family: PingFangSC-Semibold;
  .detail-header {
    position: relative;
    width: 750px;
    height: 400px;
    background-image: url("../../assets/img/buss-background.png");
    background-repeat: no-repeat;
    background-size: cover;
    .charts-gauge {
      width: 100%;
      height: 90%;
    }
    .header-info {
      width: 750px;
      color: #232c37;
      position: absolute;
      top: 300px;
      left: 0;
      z-index: 1222;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      .header-info-text {
        height: 36px;
        font-size: 26px;
        font-weight: 500;
        color: rgba(35, 44, 55, 1);
        line-height: 36px;
        margin-right: 8px;
      }
      .header-info-img {
        width: 26px;
        height: 26px;
      }
    }
  }
  .detail-main {
    padding: 0 16px;
    background: #f7f7f7;
    width: 718px;
    position: absolute;
    left: 0;
    top: 360px;
    .score-distribution {
      width: 670px;
      height: 600px;
      padding: 24px;
      position: relative;
      .charts-radar {
        width: 100%;
        height: 90%;
      }
    }
    .detail-traffic {
      margin-top: 18px;
      padding: 24px 24px 0;
      .shu {
        width: 2px;
        background: #efefef;
        height: 28px;
      }
      .item {
        height: 36px;
        font-size: 26px;
        font-weight: 400;
        line-height: 36px;
      }
      .apartment {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;
      }
      .renovation {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 40px;
      }
      .rent-trend-line {
        // position: relative;
        // left: -30px;
        width: 100%;
        height: 500px;
        .price-price{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .detail-footer {
    height: 102px;
    line-height: 102px;
    text-align: center;
    color: #BDC3CE;
    // color: rgba(49, 45, 45, 1);
    font-size: 26px;
  }
.title {
  font-size: 32px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(35, 44, 55, 1);
  line-height: 44px;
  text-align: left;
}
.subhead {
  height: 36px;
  font-size: 26px;
  font-family: PingFangSC-Medium;
  font-weight: 600;
  color: #232c37;
  line-height: 36px;
  text-align: left;
}
.common-box-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 34px 32px;
  .common-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .common-title {
      height: 36px;
      font-size: 26px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(137, 147, 159, 1);
      line-height: 36px;
      margin-bottom: 10px;
    }
    .common-info {
      height: 44px;
      font-size: 32px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(35, 44, 55, 1);
      line-height: 44px;
    }
  }
}
.main-wrapper {
  background: #fff;
  width: 670px;
  box-shadow: 0px 0px 4px 0px rgba(219, 219, 219, 0.5);
  border-radius: 6px;
}
.van-popup {
  border-radius: 8px;
  width: 560px;
}
.popup-box {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 22px 38px 40px;
  .dialog-title {
    height: 44px;
    font-size: 32px;
    color: rgba(35, 44, 55, 1);
    line-height: 44px;
    margin: 16px 0;
    font-weight: bold;
  }
  .dialog-info {
    text-align: left;
    font-size: 28px;
    color: rgba(111, 120, 132, 1);
    line-height: 40px;
  }
}
.modal-btn-wrapper {
  display: flex;
  flex-direction: row;
  height: 100px;
  line-height: 100px;
  border-top: 2px solid rgba(7, 17, 27, 0.1);
  background: #fff;
}
.confirm-btn {
  flex: 1;
  height: 90px;
  line-height: 90px;
  text-align: center;
  font-size: 32px;
}
#price_map {
  width: 100%;
  height: 308px;
  margin-top:20px;
  margin-bottom:34px;
}
}
</style>
<template>
  <div class="draw-price-container">
    <div class="detail-header">
      <Gauge class="charts-gauge" id="price-gauge" :score="score"></Gauge>
      <div class="header-info">
        <div class="header-info-text">目标区域得分</div>
        <img class="header-info-img" @click="lookScore" src="../../assets/img/wenhao.png">
      </div>
    </div>
    <div class="detail-main">
      <div class="score-distribution main-wrapper">
        <div class="title">各评分项分布</div>
        <Radar class="charts-radar" id="price-radar" :radarData="zoneDetail"></Radar>
      </div>
      <div class="detail-traffic main-wrapper">
        <div class="title">量价分析</div>
        <div class="common-box-wrapper">
          <div class="common-box">
            <div class="common-title">月租金</div>
            <div class="common-info">{{indexInfo.unitRentPrice}}元/平米</div>
          </div>
          <div class="common-box">
            <div class="common-title">挂牌量</div>
            <div class="common-info">{{indexInfo.houseNum}}</div>
          </div>
          <div class="common-box">
            <div class="common-title">挂牌周期</div>
            <div class="common-info">{{indexInfo.activeDate}}天</div>
          </div>
          <!-- <div class="common-box">
            <div class="common-title">本月新增</div>
            <div class="common-info">{{indexInfo.houseIncrement}}</div>
          </div> -->
        </div>
        <div class="subhead">挂牌房源分布</div>
        <div id="price_map"></div>
      </div>
      <!-- <div class="detail-footer">更新时间：{{rentInfo.updateTime}}</div> -->
    </div>
    <van-popup v-model="showDialog">
      <div class="popup-box">
        <div class="dialog-title">选址评分</div>
        <div
          class="dialog-info"
        >选址评分是业务团队深入了解合作商家，进行实地探访，将其在长租行业的选址经验整合沉淀、量化各类信息维度，经算法分析形成的结果。选址评分主要通过对城市配套和市场表现两个方面进行评估，满分为100分，得分越高，越适合长租公寓运营商收房选址。</div>
        <div class="dialog-title">评分维度说明</div>
        <div
          class="dialog-info"
        >城市配套是指区域范围内的居住条件，包括内部小区品质、周边的交通、生活配套，以及企业和职工密集度等市场表现是指该区域的租房市场体量、实际需求量，和长租市场发展潜力等</div>
      </div>
      <div class="modal-btn-wrapper">
        <div class="confirm-btn" style="color:#4169E1" @click="confirmPopup">知道了</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
var map;
import Bar from "@/components/echarts_bar";
import Radar from "@/components/echarts_radar";
import Gauge from "@/components/echarts_gauge";
import { Popup } from "vant";
let timestampStart,timestampEnd;
export default {
  name: "price",
  components: {
    Bar,
    Radar,
    Gauge,
    "van-popup": Popup
  },
  data() {
    return {
      showDialog: false,
      latitude: 39.908823,
      longitude: 116.397454,
      scale: 12,
      // rentInfo: {},
      score: 0,
      communityIds: 0,
      cityId: 0,
      zoneDetail: {},
      indexInfo:{}
    };
  },
  created() {
    timestampStart = (new Date()).getTime();
    this.addBuried({
      source:'1',
      eventType: '曝光事件',
      eventContent: '画圈量价分析'
    });
    let options = this.$route.query;
    this.communityIds = options.communityIds;
    this.cityId = options.cityId;
    this.latitude = options.latitude;
    this.longitude = options.longitude;
    this.getHouseDis();
    this.getZoneDetail();
    this.getIndexInfo();
  },
  mounted() {
    this.onReachBottom(e=>{
      this.addBuried({
        source:'1',
        eventType: '触底事件',
        eventContent: '画圈量价分析'
      });
    });
    map = new BMap.Map("price_map");
    var point = new BMap.Point(this.longitude, this.latitude);
    map.centerAndZoom(point, 14);
    map.disableDragging();
    map.disableDoubleClickZoom();
    map.disableScrollWheelZoom();
    map.disablePinchToZoom();
  },
  methods: {
    //查看评分标准
    lookScore() {
      this.addBuried({
        source:'1',
        eventType: '点击事件',
        eventContent: '查看评分标准'
      });
      this.showDialog = true;
    },
    confirmPopup() {
      this.showDialog = false;
    },
    //获取指标信息
    async getIndexInfo() {
      await this.$axios
        .post("api/xz/draw/index/", {
          communityIds: this.communityIds
        })
        .then(res => {
          if (res.success) {
            this.indexInfo = res.result;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取详情信息
    async getZoneDetail() {
      await this.$axios
        .post("api/xz/draw/zone/sum/", {
          communityIds: this.communityIds,
          cityId:this.cityId
        })
        .then(res => {
          if (res.success) {
            this.zoneDetail = res.result;
            this.score = res.result.score;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //挂牌房源分布
    getHouseDis() {
      this.$axios
        .post("api/xz/draw/hotmap/", {
          communityIds: this.communityIds
        })
        .then(res => {
          if (res.success) {
            let points = res.result;
            for (let i = 0; i < points.length; i++) {
              points[i].lat = points[i].latitude;
              points[i].lng = points[i].longitude;
            }
            if (!isSupportCanvas()) {
              alert(
                "热力图目前只支持有canvas支持的浏览器,您所使用的浏览器不能使用热力图功能~"
              );
            }
            let heatmapOverlay;
            heatmapOverlay = new BMapLib.HeatmapOverlay({ radius: 20 });
            map.addOverlay(heatmapOverlay);
            heatmapOverlay.setDataSet({ data: points, max: 100 });
            //是否显示热力图
            heatmapOverlay.show();
            function setGradient() {
              var gradient = {};
              var colors = document.querySelectorAll("input[type='color']");
              colors = [].slice.call(colors, 0);
              colors.forEach(function(ele) {
                gradient[ele.getAttribute("data-key")] = ele.value;
              });
              heatmapOverlay.setOptions({ gradient: gradient });
            }
            //判断浏览区是否支持canvas
            function isSupportCanvas() {
              var elem = document.createElement("canvas");
              return !!(elem.getContext && elem.getContext("2d"));
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  destroyed () {
    timestampEnd = (new Date()).getTime();
    let residenceTime = timestampEnd-timestampStart;
    this.addBuried({
      source:'1',
      eventType: '页面停留时长',
      eventContent: '画圈量价分析停留时长'+residenceTime/1000+'s'
    });
  }
};
</script>




// WEBPACK FOOTER //
// src/pages/draw_market_price/index.vue